import React from 'react';
import PropTypes from 'prop-types';
import { FDEmphasisSurface, FDStack } from '@facet-wealth/design';
import MetaControl from 'Components/UI/Meta/MetaControl';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { HeadlineTextSmall } from 'Packages/FacetDesign/Components';
import useMobileLayout from 'Hooks/useMobileLayout';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { PillarProgressIcon } from './PillarProgressIcon';
import { PillarProgressItems } from './PillarProgressItems';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('title', { _component: () => HeadlineTextSmall }, overrideReadOnly)
  .nameOverride('items', { _component: () => PillarProgressItems }, overrideReadOnly);

export const PillarProgress = ({ collection: progressCollection }) => {
  const [progressResource] = progressCollection;
  const isMobile = useMobileLayout();
  // TODO: replace with resize observer that checks for when the width of this element exceeds the width of ((its parent) - theme.spacing(2))
  const isTooSmallForPillarProgressIcon = useMediaQuery('@media (max-width: 420px)');

  return (
    <FDEmphasisSurface padding={isMobile ? 300 : 500} maxWidth={600} width="100%">
      <FDStack alignItems={'center'} spacing={2}>
        {
          isTooSmallForPillarProgressIcon || progressResource.metaField('items').attr('hidden')
            ? null
            : (
              <PillarProgressIcon
                size={isMobile ? 'sm' : 'md'}
                icon={progressResource.isTruthy('sequential') ? 'lock' : 'check'}
              />
            )
        }
        <FDStack direction={'column'} spacing={1} flex={1}>
          <MetaControl resource={progressResource} attrName={'title'} metaOverrideSet={metaOverrideSet} />
          <MetaControl resource={progressResource} attrName={'items'} metaOverrideSet={metaOverrideSet} />
          <MetaControl resource={progressResource} attrName={'progressPercent'} metaOverrideSet={metaOverrideSet} />
        </FDStack>
      </FDStack>
    </FDEmphasisSurface>
  );
};

PillarProgress.defaultProps = {
};

PillarProgress.propTypes = {
  collection: PropTypes.object.isRequired,
};

// Resize observer on pillar blue thingy, adjust as needed
